import Layout from '@components/layout/Main'
import Background from '@components/image/Background'
import PartSearchpageForm from '@components/search/forms/PartSearchpageForm'

import ViewContextProvider, { VIEWS } from '@context/ViewContext'
import BreadcrumbBar from '@components/breadcrumbs/BreadcrumbBar'
import Sort from '@components/select/Sort'
import State from '@components/select/State'
import View from '@components/select/View'

import AdList from '@components/lists/AdList'
import FAQ from '@components/shared/FAQ'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'

import SeoHeadings from '@pages/search/SearchSeoHeadings'
import Seo from 'src/seo/components/Seo'
import JsonLdSearch from 'src/seo/jsonld/JsonLdSearch'

import dbConnect from 'db/dbConnect'
import listPartAds from 'db/repo/listAds/listAdsPart' //
import sessionCookies from '@utils/sessionCookies'
import useUrlSeo from 'src/seo/server/useUrlSeo'
import useSeoArticle from 'src/seo/components/articles/useSeoArticle'
import locationLdSchema from 'src/seo/jsonld/server/locationLdSchema'
import unslugify from '@utils/links/searchUnslugifyNumericParams'
import makeSearchPartLinks from '@components/frontpage/functions/makeSearchPartLinks'
import substituteSearchQuery from '@pages/search/functions/substituteSearchQuery'

const DEFAULT_HEADINGS = {
    h1: 'Części Samochodowe',
    h2: 'Szukasz części samochodowych? Sprawdź ogłoszenia nowych i używanych części na dostawczaki.pl',
}

export default function PartSearchpage ({
    cubeLinks,
    query, offers, pagination,
    seo, locationObjectLd }) {

    const [seoArticleExcerpt, seoArticleBody] = useSeoArticle(seo.articleFile)

    return (
        <Layout>
            <Seo seo={seo} offers={offers} />
            <JsonLdSearch
                baseUrl="/czesci-auta-dostawcze"
                buy={false}
                category="Części"
                locationObjectLd={locationObjectLd}
                offers={offers} />

            <Background
                collapseWhen="form_expands"
                height={264}
                src="/backgrounds/czesci-motoryzacyjne-na-sprzedaz.webp"
                alt="Części motoryzacyjne na sprzedaż"
                z={7}>

                <PartSearchpageForm query={query} />

            </Background>

            <ViewContextProvider defaultView={VIEWS.LIST}>
                <SeoHeadings seo={seo} defaultValues={DEFAULT_HEADINGS} />
                {seoArticleExcerpt}

                <BreadcrumbBar>
                    <State />
                    <Sort />
                    <View />
                </BreadcrumbBar>

                <AdList {...{
                    below: seoArticleBody,
                    offers,
                    pagination, }} />
            </ViewContextProvider>

            <FrontpageLinks sections={cubeLinks} />

            <FAQ qa={seo.faqFile} page="part_searchpage" />
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()

    const query = unslugify(context.query)
    const cookies = sessionCookies(context)
    const { ads, pagination } = await listPartAds(query, { cookies })
    return {
        props: {
            cubeLinks: await makeSearchPartLinks(query, '/czesci-auta-dostawcze'),
            query,
            offers: ads,
            pagination,
            seo: await useUrlSeo({
                resolvedUrl: context.resolvedUrl,
                query,
                baseUrl: '/czesci-auta-dostawcze',
                substituteQuery: substituteSearchQuery(query),
            }),
            locationObjectLd: locationLdSchema(query.lokalizacja),
        }
    }
}